// @flow
export const createAPIEndpoints = ({ JSON }: Object): Object => ({
	fetch: () => JSON.get('rounds.json'),
	fetch_past_year: params => JSON.get(`archive/${params.year}/rounds.json`),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/rounds/index.js